import React from 'react'
import BEMHelper from '@ynap/bem-helper'
import Skeleton from '@ynap/skeleton'

const FormSkeleton = () => {
    const bem = new BEMHelper('FormSkeleton')

    return (
        <div className={bem('content')}>
            <Skeleton
                additionalStyle={{
                    margin: '32px auto 0',
                    height: '800px',
                    backgroundSize: '240px',
                    width: '100%',
                    maxWidth: '480px',
                }}
            />
        </div>
    )
}

export default FormSkeleton